import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import { useStaticData } from '../context/StaticDataContext';

/**
 * Resolves the current user's role name from role_id → roles lookup.
 * Always returns a lowercase string. Falls back to user.role if the
 * roles array isn't loaded yet or role_id is missing.
 */
export const useUserRoleName = () => {
  const { user } = useAuth();
  const { roles } = useStaticData();
  return useMemo(() => {
    if (user?.role_id && roles?.length) {
      const role = roles.find((r) => r.id === user.role_id);
      if (role?.name) return role.name.toLowerCase();
    }
    return (user?.role || '').toLowerCase();
  }, [user?.role_id, user?.role, roles]);
};
